import { useEffect, useState } from "react";
// import { useTranslation } from "react-i18next";
import { useNavigate, Link } from "react-router-dom";
import { useGoogleLogin, useGoogleOneTapLogin } from "@react-oauth/google";

// 領域層導入
import { ROUTES } from "@/domain/constants/routes";

// 應用層導入
import { useLogin } from "@/application/services/authService";

// 設計系統導入
// import { useTokens } from "@/design-system/hooks/useTokens";
// import { useTheme } from "@/design-system/theme/useTheme";

// // 元件導入
// import { LoginOptions } from "../components/auth";
// import { LanguageToggleButton } from "../components/common";

/**
 * LoginPage 元件 - 登入頁面
 */
export function LoginPage() {
  // const { t } = useTranslation();
  // const { isDarkMode } = useTheme();
  // const tokens = useTokens();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const { handleLoginSuccess, handleGoogleOauth, checkAuthenticated } =
    useLogin();
  const logo = "/assets/images/logo.png";

  // 檢查是否已登入
  useEffect(() => {
    if (checkAuthenticated()) {
      // navigate(ROUTES.DASHBOARD);
    }
  }, [navigate, checkAuthenticated]);

  // TODO 假如是 in app browser like thread or line then open new tab
  const isInAppBrowser = () => {
    const ua = navigator.userAgent;
    // 檢查 LINE
    if (/Line/i.test(ua)) return true;
    // 檢查 Instagram
    if (/Instagram/i.test(ua)) return true;
    // 檢查 Facebook / Messenger
    if (/FBAV|FBAN/i.test(ua)) return true;
    // Threads (通常與 Instagram 相近)
    if (/Barcelona/i.test(ua)) return true;
    return false;
  };

  const showInExternalBrowser = () => {
    alert(
      "內建瀏覽器不支援 Google 登入\n\n👉 請點右上角「⋯」 → 選「在瀏覽器中開啟」",
    );
  };

  // window.open current url NEW browser or useGoogleLogin
  const googleLogin = isInAppBrowser()
    ? showInExternalBrowser
    : useGoogleLogin({
        onSuccess: (response) => {
          setIsLoading(true);
          handleGoogleOauth(response);
        },
        onError: (err) => {
          setIsLoading(false);
          console.log("Login Failed", err);
        },
      });

  useGoogleOneTapLogin({
    onSuccess: (response) => {
      setIsLoading(true);
      handleLoginSuccess(String(response.credential));
    },
  });

  return (
    <div className="min-h-screen bg-[#FDF8F0] relative overflow-hidden font-sans">
      {/* 浮動裝飾元素 */}
      <div className="absolute w-72 h-72 bg-[#6B8E5A] bg-opacity-10 rounded-full -top-36 -right-36 animate-float hidden sm:block"></div>
      <div
        className="absolute w-48 h-48 bg-[#A0956B] bg-opacity-10 rounded-full -bottom-24 -left-24 animate-float hidden sm:block"
        style={{ animationDelay: "2s" }}
      ></div>

      {/* 主要內容 */}
      <div className="h-screen flex items-center justify-center px-4 relative z-10 pt-10">
        <div className="w-full max-w-md">
          <div className="bg-white rounded-2xl shadow-lg p-8 relative overflow-hidden mx-auto animate-fade-in">
            {/* 頂部漸變邊框 */}
            <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-[#6B8E5A] to-[#A0956B]"></div>

            {/* 裝飾背景 */}
            <div className="absolute -top-1/2 -right-1/2 w-full h-full bg-gradient-to-br from-[#6B8E5A]/5 to-[#A0956B]/5 rounded-full pointer-events-none"></div>

            {/* 標題區 */}
            <div className="text-center mb-8 relative">
              <img
                src={logo}
                alt="Logo"
                className="w-20 h-20 mx-auto mb-6 shadow-md rounded"
              />
              <h1 className="text-3xl font-bold text-[#6B8E5A] mb-2 font-serif">
                麻薏 AI 登入
              </h1>
              <p className="text-[#A0956B] text-lg">智慧營運助理</p>
            </div>

            {/* 登入表單 */}
            <div className="space-y-6">
              <button
                onClick={() => {
                  setIsLoading(true);
                  googleLogin();
                }}
                disabled={isLoading}
                className={`w-full bg-[#6B8E5A] hover:bg-[#9BBF85] text-white font-semibold py-3 px-6 rounded-full transition-all duration-300 transform hover:-translate-y-1 hover:shadow-lg flex items-center justify-center gap-3 relative overflow-hidden ${isLoading ? "opacity-70 cursor-not-allowed" : ""}`}
              >
                {isLoading ? (
                  <>
                    <i className="fas fa-spinner animate-spin text-xl"></i>
                    <span>Google 登入服務載入中，請稍候...</span>
                  </>
                ) : (
                  <>
                    <i className="fab fa-google text-lg"></i>
                    <span>使用 Google 帳號快速登入</span>
                  </>
                )}
              </button>

              {/* 提示訊息 */}
              <div className="bg-[#F5F1E8] rounded-xl p-4 flex items-start gap-3">
                <i className="fas fa-leaf text-[#6B8E5A] mt-1 flex-shrink-0"></i>
                <p className="text-[#8B7355] text-sm leading-relaxed">
                  登入後即可開始快速與 AI 助手對話。
                </p>
              </div>

              {/* 服務條款和隱私政策 */}
              <div className="text-center text-sm text-[#A0956B] leading-relaxed">
                點擊登入表示您同意我們的
                <Link
                  to="/terms"
                  className="text-[#6B8E5A] hover:text-[#9BBF85] transition-colors underline"
                >
                  服務條款
                </Link>
                和
                <Link
                  to="/privacy"
                  className="text-[#6B8E5A] hover:text-[#9BBF85] transition-colors underline"
                >
                  隱私政策
                </Link>
              </div>
            </div>

            {/* 頁尾 */}
            <div className="mt-8 pt-4 border-t border-[#F5F1E8] text-center">
              <Link
                to={ROUTES.HOME}
                className="inline-flex items-center gap-2 text-[#6B8E5A] hover:text-[#9BBF85] transition-all duration-300 font-medium text-sm group"
              >
                <i className="fas fa-arrow-left transition-transform group-hover:-translate-x-1"></i>
                <span>返回首頁</span>
              </Link>
            </div>
          </div>

          {/* 底部引用 */}
          <div className="mt-8 text-center text-[#A0956B] text-sm">
            <p className="mb-2 font-serif">
              "如同台中人熬的麻薏湯，用心陪伴每一家企業成長"
            </p>
            <p>— 麻薏 AI 團隊</p>
          </div>

          {/* 語言切換按鈕 */}
          {/* <div className="flex justify-end mt-4">
            <LanguageToggleButton />
          </div> */}
        </div>
      </div>
    </div>
  );
}
